import { useEffect } from 'react';
import { View, ActivityIndicator } from 'react-native';
import { useLocalSearchParams, useRouter } from 'expo-router';
import { useTheme } from '@/contexts/ThemeContext';

/**
 * Deep link handler for duel://gym/join/:id
 * Redirects to the existing join-gym flow with the gym ID pre-filled.
 */
export default function GymJoinRedirect() {
  const { theme } = useTheme();
  const router = useRouter();
  const { id } = useLocalSearchParams();
  const gymId = typeof id === 'string' ? id : '';

  useEffect(() => {
    if (gymId) {
      router.replace({ pathname: '/join-gym', params: { gymId } });
    } else {
      router.replace('/join-gym');
    }
  }, [gymId, router]);

  return (
    <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: theme.colors.background }}>
      <ActivityIndicator color={theme.colors.textSecondary} />
    </View>
  );
}
